<template>
<div class="wph-flex wph-border wph-border-gray-200 wph-rounded wph-text-gray-400 wph-overflow-hidden">
  <div @click="$emit('go-to-editor')"
       class="wph-w-1/2 wph-px-4 md:wph-px-6 wph-py-4 wph-relative wph-cursor-pointer"
       :class="{ 'wph-text-accent-dark': !showCart }"
  >
    <h4 class="wph-mb-1 wph-text-sm">Шаг 1: Добавить товары</h4>
    <p class="wph-whitespace-no-wrap wph-overflow-x-hidden" style="text-overflow: ellipsis;">{{ editedItem && editedItem.model ? editedItem.model.title: 'Выбрать...' }}</p>
    <div class="wph-steps-divider wph-absolute wph-top-0 wph-right-0 wph-w-12 wph-h-full wph--mr-2 wph-overflow-hidden">
      <div class="wph-absolute wph-w-24 wph-h-24 wph-border wph-border-gray-200 wph-rounded"></div>
    </div>
  </div>
  <div @click="$emit('go-to-cart')"
       class="wph-w-1/2 wph-px-4 md:wph-px-6 wph-py-4 wph-relative wph-cursor-pointer"
       :class="{ 'wph-text-accent-dark': showCart }"
  >
    <h4 class="wph-mb-1 wph-text-sm">Шаг 2: Оформить заказ</h4>
    <p v-if="!cartItemsNumber" class="wph-text-sm">Корзина пуста</p>
    <p v-else>{{ cartItemsNumber }} {{ cartItemsNumber | plural('товар', 'товара', 'товаров') }}
      на <span class="wph-font-bold">{{ cartTotal | money }}</span></p>
  </div>
</div>
</template>

<script>
export default {
  name: "Steps",
  props: {
    showCart: { type: Boolean, required: true },
    cartTotal: { required: true }
  },
  computed: {
    editedItem() {
      return this.$store.state.cart.editedItem
    },
    cartItemsNumber() {
      return this.$store.state.cart.items.length
    },
  },
}
</script>

<style scoped lang="postcss">
  .wph-steps-divider {
    & > div {
      top: 50%;
      right: 20px;
      transform: translateY(-50%) rotate(45deg);
    }
  }
</style>